<template>
  <div class="quantity buttons">
    <b-btn variant="outline-dark" class="plus" @click="onPlus()" value="plus"
    >+
    </b-btn
    >
    <b-form-input v-model="quantity" @keydown.enter.prevent="updateQuantityOfProduct()" class="qty"></b-form-input>
    <b-btn variant="outline-dark" class="minus" @click="onMinus()" value="minus"
    >-
    </b-btn
    >
  </div>
</template>


<script>
export default {
  name: "PlusMinusInput",
  props: ["qty", 'basketId', 'orderId'],
  data() {
    return {
      currentQuantity: this.qty,
    };
  },
  methods: {
    onPlus() {
      this.quantity = parseInt(this.quantity) + 1;
      let form = {
        'order_product_id': this.orderId.toString(),
        'basket_id': this.basketId.toString(),
        'quantity': this.quantity.toString()
      }
      this.$store.dispatch("ShoppingCart/updateItem", form)


    },
    onMinus() {
      if (this.quantity > 1) {
        this.quantity = parseInt(this.quantity) - 1;
        let form = {
          'order_product_id': this.orderId.toString(),
          'basket_id': this.basketId.toString(),
          'quantity': this.quantity.toString()
        }
        this.$store.dispatch("ShoppingCart/updateItem", form)
      }
    },
    updateQuantityOfProduct() {
      let form = {
        'order_product_id': this.orderId.toString(),
        'basket_id': this.basketId.toString(),
        'quantity': this.quantity.toString()
      }
      this.$store.dispatch("ShoppingCart/updateItem", form)
    }
  },
  computed: {
    quantity: {
      get() {
        return this.currentQuantity;
      },
      set(value) {
        this.currentQuantity = value;
      },
    },
  },
};
</script>

<style scoped>
.quantity {
  display: inline-block;
}

input.qty {
  width: 35px;
  height: 40px;
  padding: 0 5px;
  text-align: center;
  background-color: white;
  border: 1px solid #efefef;
  border-left: 0;
  border-right: 0;
  border-radius: 0;
}

.buttons {
  text-align: left;
  position: relative;
  white-space: nowrap;
  vertical-align: top;
}

.buttons input {
  display: inline-block;
  margin: 0;
  vertical-align: top;
  box-shadow: none;
}

.buttons button,
.buttons button:hover,
.buttons button:focus {
  border: 1px solid #efefef;
  box-shadow: none;
}

.plus,
.minus {
  padding: 7px 10px 8px;
  width: 30px;
  height: 40px;
  font-size: 20px;
  font-weight: bold;
  line-height: 1;
  color: gray;
  background-color: #ffffff;
  border: 1px solid #efefef;
  cursor: pointer;
}

.plus,
.plus:hover {
  border-radius: 0 5px 5px 0;
  border-left: 0;
}

.minus,
.minus:hover {
  border-radius: 5px 0 0 5px;
  border-right: 0;
}

.minus:hover,
.plus:hover {
  color: black;
  background: #eeeeee;
}
</style>